import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/dashboard/reservation-ledger')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
